import './App.css';
import './css/bootstrap/css/bootstrap.min.css';
import './css/c3js/c3/c3.min.css';

// import './css/c3js/c3/c3.min.js';


import React from 'react';
import {
    HashRouter as Router,
    Route,
    Switch,
    Redirect
} from 'react-router-dom';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import Main from './components/Main';
import Login from './components/Login';
import ClientDetails from './components/ClientDetails';

import StoredCommands from './components/StoredCommands';
import Commands from './components/Commands';
import Logs from './components/Logs';

import auth from './utils/authUtil';

import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

const NoMatch = () => <h3>The page you were looking for does not exist</h3>

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={
        props => (
            auth.isToken() ? 
                ( <Component {...props}/> ) : 
                ( <Redirect to='/login' /> )
        )}
    />
)

const App = () => (
    <MuiThemeProvider>
        <Router>
            <Switch>
                <PrivateRoute exact path='/' component={Main} />
                
                <Route exact path='/login' component={Login} />

                <PrivateRoute exact path='/clientdetails/:id' component={ClientDetails} />
                <PrivateRoute exact path='/storedcommands/:id' component={StoredCommands} />
                <PrivateRoute exact path='/commands/:id' component={Commands} />
                <PrivateRoute exact path='/logs/:id' component={Logs} />

                <Route component={NoMatch}/>
            </Switch>
        </Router>
    </MuiThemeProvider>
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js